import $ from 'jquery';

export default function HelpAreaFallback() {
  this.$container = $('.js-helparea-container');
  this.$template = $($('.js-helparea-fallback-template').html());
  this.toggleFallbackWindow = this.toggleFallbackWindow.bind(this);
  this.closeFallbackWindow = this.closeFallbackWindow.bind(this);

  this.showFallbackButton();
}

$.extend(HelpAreaFallback.prototype, {
  showFallbackButton: function() {
    $('body').on('click', this.$template, this.toggleFallbackWindow);
    this.$container.on('click', '.js-helparea-close', this.closeFallbackWindow);

    this.$container.html(this.$template);
  },

  toggleFallbackWindow: function(e) {
    if (
      this.$template.has(e.target).length === 0 &&
      !this.$template.is(e.target)
    ) {
      this.$template.removeClass('helparea__wrapper--active');
    } else {
      this.$template.addClass('helparea__wrapper--active');
    }
  },

  closeFallbackWindow: function(e) {
    e.stopPropagation();

    this.$template.removeClass('helparea__wrapper--active');
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/helparea/fallback.js
 **/